import { render } from "./wishlist-button.vue?vue&type=template&id=6fe452f9"
import script from "./wishlist-button.vue?vue&type=script&lang=js"
export * from "./wishlist-button.vue?vue&type=script&lang=js"

import "./wishlist-button.vue?vue&type=style&index=0&id=6fe452f9&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__